<template>
  <v-dialog
    v-model="dialog"
    max-width="550"
  >
    <v-card>
      <v-card-title class="headline">Izberite poslovno enoto</v-card-title>
      <v-card-text>
        <v-container>
          <v-row
            class="results"
          >
            <v-col
              cols="12"
              v-for="item of businessUnits"
              :key="item.id"
            >
              <v-btn
                style="width: 100%"
                class="float-right"
                :disabled="item.id === currentBusinessUnit.id"
                @click="selectBusinessUnit(item)"
              >
                {{item.name}}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#0F998E"
          text
          @click="dialog = false"
        >
          Prekliči
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { objectToArray } from '@/utils/object'

export default {
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  computed: {
    currentBusinessUnit () {
      return this.$store.state.businessUnits.currentBusinessUnit
    },
    businessUnits () {
      return objectToArray(this.$store.state.businessUnits.items)
    }
  },
  created () {
    if (!this.businessUnits) {
      this.loadItems()
    }
  },
  methods: {
    ...mapActions('businessUnits', ['loadItems', 'selectCurrent']),
    selectBusinessUnit (item) {
      this.selectCurrent(item)
      this.dialog = false
      location.reload()
    }
  },
  watch: {
    value (newVal) {
      this.dialog = newVal
    },
    dialog (dialog) {
      this.$emit('input', dialog)
    }
  }
}
</script>
